module.exports = __webpack_public_path__ + "img/singtao.acc8972f.png";